import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '@env';

import { AuthStorageService } from '../services/auth-storage.service';

function isApiRequest(url: string, apiUrl: string): boolean {
  return url.startsWith(apiUrl);
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url, environment.apiUrl)) {
    return next(req);
  }
  const token = inject(AuthStorageService).accessToken();
  const withCreds = req.clone({ withCredentials: true });
  if (!token) {
    return next(withCreds);
  }
  return next(
    withCreds.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    }),
  );
};
